var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBbva(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150.1 45",
    style: {
      enableBackground: "new 0 0 150.1 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#107569;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.1,6.1L95.2,30.7c-0.3,0.5-1,0.5-1.4,0L80.9,6.1c-0.1-0.3-0.4-0.4-0.6-0.4h-6.2c-0.4,0-0.6,0.5-0.5,0.8 L94,44.6c0.3,0.5,1,0.5,1.3,0l20.4-38.1c0.3-0.4-0.1-0.8-0.5-0.8h-6.2C108.6,5.6,108.4,5.9,108.1,6.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.5,38.9l12.9-24.6c0.3-0.5,1-0.5,1.4,0l12.9,24.6c0.1,0.3,0.4,0.4,0.6,0.4h6.2c0.4,0,0.6-0.5,0.5-0.8 L129.6,0.4c-0.3-0.5-1-0.5-1.3,0L108,38.5c-0.3,0.4,0.1,0.8,0.5,0.8h6.2C115.1,39.3,115.4,39.1,115.5,38.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.3,23.8c2.7-1.4,4.3-4.2,4.3-7.9c0-6.1-4.7-10.3-11.5-10.3H0.8C0.4,5.6,0,6,0,6.4v37.7 c0,0.4,0.4,0.8,0.8,0.8h18.5c9.3,0,14.2-4,14.2-11.7C33.4,25.5,27.3,23.8,27.3,23.8 M7.3,11.3h11.5c4.2,0,6.4,1.8,6.4,5.1 s-2.2,5.1-6.4,5.1H7.3c-0.4,0-0.8-0.4-0.8-0.8V12C6.5,11.7,6.9,11.3,7.3,11.3 M19,39.3H7.4c-0.4,0-0.8-0.4-0.8-0.8V28 c0-0.4,0.4-0.8,0.8-0.8H19c5.6,0,8,1.5,8,6S24.5,39.3,19,39.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.9,23.8c2.7-1.4,4.3-4.2,4.3-7.9c0-6.1-4.7-10.3-11.5-10.3H40.4c-0.4,0-0.8,0.4-0.8,0.8v37.7 c0,0.4,0.4,0.8,0.8,0.8h18.5c9.3,0,14.2-4,14.2-11.7C73.2,25.5,66.9,23.8,66.9,23.8 M47,11.3h11.5c4.2,0,6.4,1.8,6.4,5.1 s-2.2,5.1-6.4,5.1H47c-0.4,0-0.8-0.4-0.8-0.8V12C46.3,11.7,46.5,11.3,47,11.3 M58.6,39.3H47c-0.4,0-0.8-0.4-0.8-0.8V28 c0-0.4,0.4-0.8,0.8-0.8h11.6c5.6,0,8,1.5,8,6S64.2,39.3,58.6,39.3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBbva);
export default __webpack_public_path__ + "static/media/logo-bbva.993055409f2a2c1ecae6ae5563bbb539.svg";
export { ForwardRef as ReactComponent };